import getIn from 'transmute/getIn';
const STRING_COLLATOR = window.Intl && typeof window.Intl === 'object' && new Intl.Collator();
export const compareStr = (str, otherStr, asc = true) => {
  const modifier = asc ? 1 : -1;
  if (str === null || str === undefined || otherStr === null || otherStr === undefined) {
    console.warn('compareStr called with undefined or null parameters!');
    return 0;
  }
  const str1 = str.toLowerCase();
  const str2 = otherStr.toLowerCase();
  let comparisonResult = 0;
  if (STRING_COLLATOR) {
    // Intl.Collator is faster than localeCompare:
    // See docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare#Performance
    comparisonResult = STRING_COLLATOR.compare(str1, str2);
  } else {
    comparisonResult = str1.localeCompare(str2);
  }
  return comparisonResult * modifier;
};

/**
 * - keyPath:   array of strings; representing path in obj
 * - asc:       bool; if false, reverses sorting
 */
export const compareStrWithKeyPath = (keyPath, asc = true) => (item, otherItem) => {
  const str = getIn(keyPath, item);
  const otherStr = getIn(keyPath, otherItem);
  return compareStr(str, otherStr, asc);
};